import gsap from "gsap"
import style from './Morals.module.css'
import { useEffect, useState } from "react"
import logo from '../assets/Your paragraph text.png';


export default function Morals()
{
    useEffect(() => {
        gsap.fromTo("#flashingText", {color: 'red',}, {color: "yellow", repeat: -1, yoyo: 'true'})
        gsap.fromTo("#flashingText", {x: -500}, {x: 500, repeat: -1, yoyo: 'true', duration: 10})
    })

    const fortunes = [
        "A beautiful, smart, and loving person will be coming into your life.",
        "A dubious friend may be an enemy in camouflage.",
        "A faithful friend is a strong defense.",
        "A feather in the hand is better than a bird in the air.",
        "A fresh start will put you on your way.",
        "A friend asks only for your time, not your money.",
        "A friend is a present you give yourself.",
        "A gambler not only will lose what he has, but also will lose what he doesn’t have.",
        "A golden egg of opportunity falls into your lap this month.",
        "A good friendship is often more important than a passionate romance.",
        "A good time to finish up old tasks.",
        "A hunch is creativity trying to tell you something.",
        "A lifetime friend shall soon be made.",
        "A light heart carries you through all the hard times.",
        "A new outlook brightens your image and brings new friends.",
        "A new perspective will come with the new year.",
        "A person of words and not deeds is like a garden full of weeds.",
        "A pleasant surprise is waiting for you.",
        "A short pencil is usually better than a long memory any day.",
        "A small donation is called for. It’s the right thing to do.",
        "A smile is your personal welcome mat.",
        "A smooth long journey! Great expectations.",
        "A truly rich life contains love and art in abundance.",
        "Accept something that you cannot change, and you will feel better.",
        "Adventure can be real happiness.",
        "Advice is like kissing. It costs nothing and is a pleasant thing to do.",
        "All the effort you are making will ultimately pay off.",
        "All the troubles you have will pass away very quickly.",
        "Allow compassion to guide your decisions.",
        "An agreeable romance might begin to take on the appearance of something more.",
        "An important person will offer you support.",
        "Any day above ground is a good day.",
        "At the touch of love, everyone becomes a poet.",
        "Beauty in its various forms appeals to you.",
        "Believe in yourself and others will too.",
        "Better ask twice than lose yourself once.",
        "Bide your time, for success is near.",
        "Chance favors those in motion.",
        "Change is happening in your life, so go with the flow!",
        "Courtesy is contagious.",
        "Curiosity kills boredom. Nothing can kill curiosity.",
        "Dedicate yourself with a calm mind to the task at hand.",
        "Depart not from the path which fate has you assigned.",
        "Determination is what you need now.",
        "Diligence and modesty can raise your social status.",
        "Disbelief destroys the magic.",
        "Distance yourself from the vain.",
        "Don’t be discouraged; every wrong attempt discarded is another step forward.",
        "Don’t confuse recklessness with confidence.",
        "Don’t let ambitions overshadow small success.",
        "Don’t let your limitations overshadow your talents.",
        "Don’t worry; prosperity will knock on your door soon.",
        "Each day, compel yourself to do something you would rather not do.",
        "Education is the ability to meet life’s situations.",
        "Embrace this love relationship you have!",
        "Every flower blooms in its own sweet time.",
        "Every wise man started out by asking many questions.",
        "Expect much of yourself and little of others.",
        "Failure is the chance to do better next time.",
        "Fearless courage is the foundation of victory.",
        "Follow the middle path. Neither extreme will make you happy.",
        "For hate is never conquered by hate. Hate is conquered by love.",
        "Fortune Not Found: Abort, Retry, Ignore?",
        "From listening comes wisdom, and from speaking repentance.",
        "Get your mind set—confidence will lead you on.",
        "Go take a rest; you deserve it.",
        "Good news will be brought to you by mail.",
        "Happiness begins with facing life with a smile and a wink.",
        "Hard words break no bones; fine words butter no parsnips.",
        "He who knows others is wise. He who knows himself is enlightened.",
        "How many of you believe in psycho-kinesis? Raise my hand.",
        "If you continually give, you will continually have.",
        "Imagination rules the world.",
        "In order to take, one must first give.",
        "It takes courage to admit fault.",
        "Keep your face to the sunshine and you will never see shadows.",
        "Listen to everyone. Ideas come from everywhere.",
        "Miles are covered one step at a time.",
        "Nature, time, and patience are the three great physicians.",
        "Never fear! The end of something marks the start of something new.",
        "No one can walk backwards into the future.",
        "Pick battles big enough to matter, small enough to win.",
        "Protective measures will prevent costly disasters.",
        "Remember to share good fortune as well as bad with your friends.",
        "Rest has a peaceful effect on your physical and emotional health.",
        "Savor your freedom—it is precious.",
        "Self-knowledge is a lifelong process.",
        "Strong reasons make strong actions.",
        "Success is a journey, not a destination.",
        "Take care and sensitivity you show towards others will return to you.",
        "The architect of your destiny is yourself.",
        "The best prediction of the future is the past.",
        "The greatest achievement in life is to stand up again after falling.",
        "The harder you work, the luckier you get.",
        "The only people who never fail are those who never try.",
        "The saints are the sinners who keep on trying.",
        "There is no wisdom greater than kindness.",
        "Time and patience are called for; many surprises await you.",
        "To the world you may be one person, but to one person you may be the world.",
        "Tonight you will be blinded by passion.",
        "Use your eloquence where it will do the most good.",
        "Well done is better than well said.",
        "What’s hidden in an empty box?",
        "You are admired by everyone for your talent and ability.",
        "You are busy, but you are happy.",
        "You are generous to an extreme and always think of the other fellow.",
        "You are modest and courteous.",
        "You have exceeded what was expected.",
        "You look pretty.",
        "You love challenge.",
        "Your hard work will pay off today.",
        "Your mind is creative, original, and alert.",
        "Your reputation is your wealth.",
        "Your success will astonish everyone.",
        "Your talents will be recognized and suitably rewarded.",
        "Your work interests can capture the highest status or prestige."
    ];


    const [theFortune, setFortune] = useState('')

    return(
        <div className = {style.Container}>
            <h2>MORALS</h2>
            <h2>1) To steal is not good. </h2>

            <img style = {{pointerEvents: 'none'}} className={style.Img} src = {logo} />

            <h2 className={style.Header} id = "flashingText">MORALS 🐲</h2>
            <h2>2) To make friends, be nice</h2>
            <h2>3) Gang banging leads to drug or prison</h2>
            <h2>5) Always pick more fruit than so you give to the neighbor </h2>
            <h2>5) If you do naughty, do not spread germs </h2>
            <h2>5) Aways pick up of garbage </h2>

            <button style = {{zIndex: 1024912}} onClick={() => {
                if(theFortune !== '')
                {
                    setFortune('This is very naughty... Please read morals')
                }
                else
                {
                    setFortune(fortunes[Math.floor(Math.random() * fortunes.length)])
                }
            }}>Click for fortune (only click the once for good luck)</button>
            <p style = {{color: 'white'}}>{`Your fortune: ${theFortune}`}</p>

        </div>
    )
}